import React, { FC, ReactNode } from 'react'
import { Stack } from '@mui/material'

// Notion 流 filter bar. 28-height inline row, Card 不使用.
// caller は <FilterBar><TextField /><Select /><DatePicker />...</FilterBar> で並べる.
interface FilterBarProps {
  children: ReactNode
  /** 右側に push する actions (= 「クリア」「今日へ」 等). 任意. */
  trailing?: ReactNode
}

export const FilterBar: FC<FilterBarProps> = ({ children, trailing }) => (
  <Stack
    direction="row"
    alignItems="center"
    gap={1.5}
    flexWrap="wrap"
    sx={{
      '& .MuiTextField-root, & .MuiFormControl-root': {
        minWidth: 160,
      },
      '& .MuiInputBase-root': {
        height: 32,
        fontSize: 14,
      },
    }}
  >
    {children}
    {trailing && (
      <Stack direction="row" gap={1} sx={{ ml: 'auto' }}>
        {trailing}
      </Stack>
    )}
  </Stack>
)
